import Vue from 'vue'
import VueRouter from 'vue-router';

import File from './components/File';
import Group from './components/Group';
import GameDownload from './components/GameDownload';
import ImporterDownload from './components/ImporterDownload';
import CharacterImporter from './components/CharacterImporter';
import InteractionStudioHomepage from './components/InteractionStudioHomepage';
import Tutorials from './components/tutorials/Tutorials';
import StudioGuides from './components/interaction-studio/StudioGuides';
import Legacy from './components/Legacy';
import Home from './components/Home';
import UserManualHomepage from './components/UserManualHomepage';
import ManualPages from './components/user-manual/ManualPages';

Vue.use(VueRouter);

const routes = [
	{
		component: File,
		name: 'file',
		path: '/:groupName(builds|junk|pics|shorts|wips)/:fileId',
	},
	{
		component: Group,
		name: 'group',
		path: '/legacy/:groupName(builds|junk|pics|shorts|wips)',
	},
	{
		component: GameDownload,
		name: 'download',
		path: '/download',
	},
	{
		component: ImporterDownload,
		name: 'importer-download',
		path: '/importer-download',
	},
	{
		component: CharacterImporter,
		name: 'character-importer',
		path: '/character-importer',
	},
	{
		component: InteractionStudioHomepage,
		name: 'interaction-studio',
		path: '/interaction-studio',
	},
	{
		component: Tutorials,
		name: 'tutorials',
		path: '/tutorials/:tutorialName',
	},
	{
		component: StudioGuides,
		name: 'interaction-studio-guides',
		path: '/interaction-studio-guides/:guideName',
	},
	{
		component: UserManualHomepage,
		name: 'user-manual',
		path: '/user-manual',
	},
	{
		component: ManualPages,
		name: 'user-manual-pages',
		path: '/user-manual/:pageName',
	},
	{
		component: Legacy,
		name: 'legacy',
		path: '/legacy',
	},
	{
		component: Home,
		name: 'home',
		path: '*',
	},
];

export const router = new VueRouter({
	mode: 'history',
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			if (to.hash) {
				document.querySelector(to.hash)?.scrollIntoView()
			} else {
				window.scrollTo(0, 0)
			}
		}
	},
});
